import {Component, Input, OnInit, TemplateRef} from '@angular/core';
import {animate, sequence, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'lm-full-panel-container',
  templateUrl: './full-panel-container.component.html',
  styleUrls: ['./full-panel-container.component.less'],
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: `translateX(-1300px)`}), animate('0.1s')]),
      transition(":leave", [sequence([style({left: '56px'}), animate('0.1s', style({left: '-1300px'}))])]),
    ])
  ]
})
export class FullPanelContainerComponent implements OnInit {

  @Input() isVisible = false;
  @Input() currentTemplate: TemplateRef<any> | null = null;

  constructor() { }

  ngOnInit(): void {
  }

}
